const addAVehicleEvent = {
  category: "Header",
  action: "Add A Vehicle",
  label: "",
};

const addVehicleEvent = {
  category: "Header",
  action: "Add Vehicle",
  label: "",
};

const addRaceCarEvent = {
  category: "Header",
  action: "Add Race Car",
  label: "",
};

const viewGarageEvent = {
  category: "Header",
  action: "View your Garage",
  label: "",
};

export { addAVehicleEvent, addVehicleEvent, addRaceCarEvent, viewGarageEvent };
